import { Ds } from "@accurx/design";
import { Pill } from "@accurx/inbox-design-library";
import styled from "styled-components";

export const StyledScheduledSendInfo = styled(Ds.Flex).attrs({
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1",
})<{ $hasError?: boolean }>`
    background: var(--ds-color-cloud);

    box-shadow: ${({ $hasError }) =>
        $hasError ? "inset 0 0 0 1px var(--ds-color-red-100)" : "none"};

    padding: 0.5rem;

    border-radius: 0.25rem;
`;

export const StyledPillButton = styled(Pill.Button)`
    padding: 0.25rem;
`;
